<template>
  <div>
    <Modal v-model="visible" title="批量分配业务员" class="my-modal" :footer-hide="true" :mask-closable="false" width="1000">
      <div slot="header">
        <Poptip trigger="hover" transfer>
          <Icon type="ios-help-circle-outline" />
          <span class="modal-title">批量分配业务员</span>
          <template #content>
            当前显示的为可分配份额，只可变更当前可用份额
          </template>
        </Poptip>
        <span>
          可分配份额：
          <em class="table-btn def">{{ remainGiftNum }}</em>
        </span>
      </div>
      <loading :isShow="pageLoading" />
      <div class="tools-box">
        <div class="text1">分配产品:{{ row.productName }}</div>
        <Button type="primary" @click="importData">导入</Button>
      </div>
      <Transfer
        v-if="visible"
        :data="allData"
        :target-keys="addDataKeys"
        filterable
        @on-change="handleChange"
        :list-style="{ width: '430px', height: '400px' }"
        :titles="['待分配业务员', '已选业务员']"
      ></Transfer>
      <Form class="page-form" ref="myForm" :model="formData" :label-width="90">
        <FormItem prop="giftNum" label="分配次数" :rules="[$units.formRule.required('分配次数不能为空', 'blur'), $units.formRule.IntSort('请输入大于0的整数')]">
          <Input v-model="formData.giftNum" placeholder="请输入" clearable />
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save">确定</Button>
      </div>
    </Modal>
    <!-- 导入 -->
    <import-tool ref="importTool" @success="importCallback()"></import-tool>
  </div>
</template>

<script>
import importTool from '@/components/commons/importTool/index2';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: { importTool },
  props: {
    //商户剩余份额
    remainGiftNum: null
  },
  data() {
    return {
      formData: {},
      row: {},
      addDataKeys: [],
      allData: [],
      visible: false,
      pageLoading: false
    };
  },
  methods: {
    async open(row = {}) {
      if (!this.$units.pointAction('recruiting_3_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.row = row;
      this.formData = {
        merchantJoinId: row.id,
        productCode: row.productCode,
        giftNum: ''
      };
      this.addDataKeys = [];
      this.pageLoading = true;
      this.clearValidate();
      this.visible = true;
      await this.getUserList();
      this.pageLoading = false;
    },
    save() {
      this.$refs.myForm.validate(valid => {
        if (!valid) {
          return;
        }
        if (!this.addDataKeys || this.addDataKeys.length == 0) {
          this.$notice.msg('请选择待分配的业务员');
          return;
        }
        if (this.pageLoading) {
          return;
        }
        this.formData.salesmanIds = this.addDataKeys;
        this.pageLoading = true;
        this.$http({
          url: '/buz/giveawayProduct/allocateSalesman',
          type: 'POST',
          data: this.formData
        })
          .then(res => {
            this.$notice.success('操作成功');
            this.visible = false;
            this.$emit('reload');
          })
          .finally(() => {
            window.setTimeout(() => {
              this.pageLoading = false;
            }, 500);
          });
      });
    },
    // 获取该赠险的业务员数据
    getUserList() {
      return this.$http({
        url: '/buz/giveawayProduct/queryAllocateSalesmanList',
        type: 'POST',
        data: {
          merchantJoinId: this.row.id
        }
      }).then(res => {
        this.allData = res.data.map(item => {
          item.key = item.id;
          item.label = `${item.name}(${item.organizationName}/${item.groupName})`;
          return item;
        });
      });
    },
    // 选择商户
    handleChange(addDataKeys) {
      this.addDataKeys = addDataKeys;
    },
    // 导入完成回调
    importCallback() {
      this.visible = false;
      this.$emit('reload');
    },
    // 导入
    importData() {
      const dic = JSON.parse(localStorage.dic)['GIVEAWAY_ALLOCATE_SALESMAN_TEMPLATE'];
      const key = Object.getOwnPropertyNames(dic)[0];
      this.$refs.importTool.open({
        params: {},
        uploadParams: {
          merchantJoinId: this.row.id
        },
        template: key,
        templateName: dic[key],
        uploadUrl: '/buz/giveawayProduct/batchAllocateSalesman',
        errorUrl: '/buz/giveawayProduct/exportError'
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.my-modal {
  /deep/.ivu-icon-ios-help-circle-outline{
    margin-right: 2px;
    font-weight: 600;
    color: #666;
    font-size: 18px;
    cursor: pointer;
    transform: translateY(1px);
  }
  .text1 {
    font-size: 16px;
    font-weight: bold;
    padding: 10px 0;
  }
  /deep/ .template-name {
    color: #236dff;
  }
  /deep/ .commission-level {
    color: #f59045;
  }
  .page-form {
    text-align: center;
  }
  .tools-box {
    padding-top: 10px;
    padding-right: 8px;
  }
  .modal-title {
    color: #3c464f;
    font-weight: bold;
    margin-right: 15px;
  }
}
</style>
